import React from 'react';
import PropTypes from 'prop-types';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import useLaunchDarklyIdentify from '../../hooks/useLaunchDarklyIdentify';

const LaunchDarklyClient = ({
  spaceId,
  currentUserId,
  institutionName,
  children,
}) => {
  const launchDarklyClient = useLDClient();

  useLaunchDarklyIdentify({
    spaceId,
    currentUserId,
    institutionName,
    launchDarklyClient,
  });

  return children;
};

LaunchDarklyClient.propTypes = {
  spaceId: PropTypes.string,
  institutionName: PropTypes.string.isRequired,
  currentUserId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

LaunchDarklyClient.defaultProps = {
  spaceId: undefined,
};

export default LaunchDarklyClient;
